import React from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip, Radio, DatePicker } from 'hljd'
import { splitStrToChunks, isToday } from '@hlj/hlj-utils'
import { ANALYSIS_LIST, RADIO_GROUP, ZHI_GUANG_TONG } from './constant'
import Store from './store'
import cls from 'classnames'
import dayjs from 'dayjs'
import styles from './index.module.less'
import { isWeddingDressPhotoProperty } from '@merchant-backend/util'

// 图表组件
import Charts from './charts'

/*
* name: 推广中心-一般通用数据分析图表
* props:
*     productType : zhiTuiBao、zhiGuangTong
*     className
*     style
* */

// 禁止可选日期
const disabledDate = current => {
  return (
    current &&
    (current < dayjs().subtract(90, 'days') || current > dayjs().endOf('day'))
  )
}

@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.store = new Store(this.props)
  }

  componentDidMount() {
    this.store.getAnalysisData()
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this.store.updateProps(nextProps)
    }
  }

  render() {
    const { productType, className = '', style = {} } = this.props || {}
    const {
      handleClickAnalysisType,
      activeAnalysisTypeKey,
      rangePickerValue,
      changeRangePicker,
      dateRadioValue,
      changeDateRadio,
      dataSource = {},
      typeValue,
      changeTypeRadio
    } = this.store
    const summer = dataSource.summer || {}
    const analysisChartClass = cls({
      [styles.analysis_chart_wrap]: true,
      [className]: className
    })

    return (
      <div style={style} className={analysisChartClass}>
        <div className={styles.search_bar}>
          <div>
            <span className={styles.date_label}>日期：</span>
            <DatePicker.RangePicker
              disabledDate={disabledDate}
              value={
                rangePickerValue
                  ? [
                      toJS(rangePickerValue[0])
                        ? dayjs(toJS(rangePickerValue[0]), 'YYYY-MM-DD')
                        : '',
                      toJS(rangePickerValue[1])
                        ? dayjs(toJS(rangePickerValue[1]), 'YYYY-MM-DD')
                        : ''
                    ]
                  : undefined
              }
              className={styles.date_picker}
              onChange={changeRangePicker()}
            />
          </div>
          <Radio.Group
            value={dateRadioValue}
            buttonStyle="solid"
            className={styles.date_radio}
            onChange={changeDateRadio()}
          >
            {RADIO_GROUP.map(({ label, value }) => (
              <Radio.Button value={value}>{label}</Radio.Button>
            ))}
          </Radio.Group>
          {/* {productType == ZHI_GUANG_TONG &&
            isWeddingDressPhotoProperty() && (
              <Radio.Group
                value={typeValue}
                buttonStyle="solid"
                className={styles.date_radio}
                onChange={changeTypeRadio}
              >
                <Radio.Button value={''}>全部数据</Radio.Button>
                <Radio.Button value={'1'}>夜间计划数据</Radio.Button>
              </Radio.Group>
            )} */}
        </div>
        <br />
        <ul className={styles.analysis_overview}>
          {(ANALYSIS_LIST[productType] || []).map(item => {
            const { label, unit, key, valueUnit, help } = item
            const dataKey = key.split('@')[1]
            const value = Number(summer[dataKey] || 0)
            const numberValue = !Number.isInteger(value)
              ? value.toFixed(2)
              : value
            const [start, end] = rangePickerValue || []
            const today =
              dateRadioValue === '0' ||
              (start && end && isToday(start) && isToday(end))
            let textValue = ''
            const showTomorrowText =
              dataKey == 'daily_interest_count' ||
              dataKey == 'daily_convert_count'

            if (today && showTomorrowText) {
              textValue = '次日更新'
            }

            const liItemClass = cls({
              [styles.li]: true,
              [styles.li_active]: activeAnalysisTypeKey === key
            })
            return (
              <li
                className={liItemClass}
                key={key}
                onClick={handleClickAnalysisType(key)}
              >
                <dt>
                  {label}
                  {unit ? '(' + unit + ')' : ''}
                  &thinsp;
                  <Tooltip title={help}>
                    <QuestionCircleOutlined style={{ fontSize: 12 }} />
                  </Tooltip>
                </dt>
                <dd>
                  {textValue || splitStrToChunks(numberValue, 3)}
                  {valueUnit}
                </dd>
              </li>
            )
          })}
        </ul>
        <br />
        <div className={styles.charts}>
          <Charts store={this.store} />
        </div>
      </div>
    )
  }
}
